import { GlobalStyles } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { getResponsiveStyles } from "./responsiveStyles";

/**
 * Injects responsive styles using MUI theme.breakpoints (built-in).
 * Replaces custom @media in CSS files.
 */
const ResponsiveGlobalStyles = () => {
  const theme = useTheme();
  const styles = getResponsiveStyles(theme);
  return <GlobalStyles styles={styles} />;
};

export default ResponsiveGlobalStyles;
